// extracted by mini-css-extract-plugin
module.exports = {"delete":"CellListDraggableCell_delete__1-T4x"};